const { PhoneNumberUtil, PhoneNumberType } = require('google-libphonenumber')
const { normalizePhone } = require('./normalizePhone')
const { PHONE_REGIONS } = require('./phoneRegions')

const phoneUtil = PhoneNumberUtil.getInstance()
const CALLABLE_TYPES = [
  PhoneNumberType.FIXED_LINE,
  PhoneNumberType.MOBILE,
  PhoneNumberType.FIXED_LINE_OR_MOBILE,
]

function isSupportedPhoneNumber(value) {
  const normalized = normalizePhone(value)
  if (!/^\+[1-9]\d+$/.test(normalized)) return false

  let parsed
  try {
    parsed = phoneUtil.parse(normalized)
  } catch (error) {
    return false
  }

  if (!phoneUtil.isValidNumber(parsed)) return false
  if (CALLABLE_TYPES.indexOf(phoneUtil.getNumberType(parsed)) === -1) return false

  const region = phoneUtil.getRegionCodeForNumber(parsed)
  return PHONE_REGIONS.indexOf(region) !== -1
}

const phoneValidateRules = {
  required: true,
  validate: (value) => isSupportedPhoneNumber(value),
}

module.exports = { isSupportedPhoneNumber, phoneValidateRules }
